<header class="app-header" role="banner">
  <div class="app-header__inner">
    <img
      class="app-header__banner"
      src="assets/images/common/TX_ShowPass_Logo.webp"
      alt="Texas ShowPass | Powered by Capital Farm Credit"
      width="420"
      height="70"
    />

    <div class="app-header__actions">
      <a
        *ngIf="activeShow"
        class="app-header__all-shows"
        [routerLink]="activeShow.switchRoute || '/family/shows'">
        <i class="pi" [ngClass]="activeShow.switchIcon || 'pi-arrow-left'"></i>
        <span>{{ activeShow.switchLabel || 'All Shows' }}</span>
      </a>

      <ng-container *ngIf="profile as p">
        <!-- With a menu the chip is a real button; without one it is plain text. -->
        <button
          *ngIf="showLogout; else staticChip"
          type="button"
          class="app-header__profile app-header__profile--clickable"
          [class.app-header__profile--open]="menuOpen"
          aria-haspopup="menu"
          [attr.aria-expanded]="menuOpen"
          [attr.aria-label]="'Account menu for ' + p.name"
          (click)="profileMenu.toggle($event)">
          <ng-container *ngTemplateOutlet="chip; context: { $implicit: p }"></ng-container>
          <i class="pi pi-chevron-down app-header__caret" aria-hidden="true"></i>
        </button>

        <ng-template #staticChip>
          <div class="app-header__profile">
            <ng-container *ngTemplateOutlet="chip; context: { $implicit: p }"></ng-container>
          </div>
        </ng-template>
      </ng-container>

      <!-- The org picker passes initials only, so the text block is optional. -->
      <ng-template #chip let-p>
        <span class="app-header__identity" *ngIf="hasIdentity">
          <span class="app-header__name" *ngIf="p.name">{{ p.name }}</span>
          <span class="app-header__role" *ngIf="p.location">{{ p.location }}</span>
        </span>
        <span class="app-header__avatar" aria-hidden="true">{{ p.initials }}</span>
      </ng-template>

      <!-- Body-appended, so the popup is skinned from styles.scss, not here. -->
      <p-menu
        #profileMenu
        [model]="menuItems"
        [popup]="true"
        appendTo="body"
        styleClass="app-header__menu"
        (onShow)="menuOpen = true"
        (onHide)="menuOpen = false">
        <!-- Repeats the identity: the chip it drops from is white-on-navy and
             easy to lose track of once the panel covers it. -->
        <ng-template pTemplate="start">
          <div class="app-header__menu-head" *ngIf="profile as p">
            <span class="app-header__menu-avatar" aria-hidden="true">{{ p.initials }}</span>
            <span class="app-header__menu-identity">
              <span class="app-header__menu-name" *ngIf="p.name">{{ p.name }}</span>
              <span class="app-header__menu-role" *ngIf="p.location">{{ p.location }}</span>
            </span>
          </div>
        </ng-template>
      </p-menu>
    </div>
  </div>
</header>
